<script lang="ts" setup>
import dayjs from 'dayjs'

export interface PagebuilderCountdownProps {
    data: {
        name: string
        description: string
        datetime: Date
    }
}
const props = defineProps<PagebuilderCountdownProps>()

const countdown = ref(null)

const time = reactive({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
})

const calculateTimeLeft = () => {
    const now = dayjs()
    const target = dayjs(props.data.datetime)
    const difference = target.diff(now)

    if (difference > 0) {
        time.days = target.diff(now, 'day')
        time.hours = target.diff(now, 'hour') % 24
        time.minutes = target.diff(now, 'minute') % 60
        time.seconds = target.diff(now, 'second') % 60
    } else {
        time.days = 0
        time.hours = 0
        time.minutes = 0
        time.seconds = 0
    }
}

onMounted(() => {
    calculateTimeLeft()
    countdown.value = window.setInterval(calculateTimeLeft, 1000) as unknown as null
})

onBeforeUnmount(() => {
    if (countdown.value) {
        clearInterval(countdown.value)
    }
})
</script>

<template>
  <div class="mb-12 mb-md-20">
    <div class="text-center">
      <h3
        v-if="props.data.name"
        class="mb-6"
      >
        {{ props.data.name }}
      </h3>

      <div class="d-flex justify-content-center gap-4 mb-6">
        <div class="text-center d-flex flex-column align-items-center">
          <span
            class="mb-2 text-secondary fw-semibold bg-white rounded-3 shadow beta d-flex justify-content-center align-items-center"
            style="width: 70px; height: 70px"
          >
            {{ time.days }}
          </span>
          <span class="fs-normal fw-semibold">Dní</span>
        </div>
        <div class="text-center d-flex flex-column align-items-center">
          <span
            class="text-secondary mb-2 fw-semibold bg-white p-5 rounded-3 shadow beta d-flex justify-content-center align-items-center"
            style="width: 70px; height: 70px"
          >
            {{ time.hours }}
          </span>
          <span class="fs-normal fw-semibold">Hodín</span>
        </div>
        <div class="text-center d-flex flex-column align-items-center">
          <span
            class="text-secondary mb-2 fw-semibold bg-white p-5 rounded-3 shadow beta d-flex justify-content-center align-items-center"
            style="width: 70px; height: 70px"
          >
            {{ time.minutes }}
          </span>
          <span class="fs-normal fw-semibold">Minút</span>
        </div>
        <div class="text-center d-flex flex-column align-items-center">
          <span
            class="text-secondary mb-2 fw-semibold bg-white p-5 rounded-3 shadow beta d-flex justify-content-center align-items-center"
            style="width: 70px; height: 70px"
          >
            {{ time.seconds }}
          </span>
          <span class="fs-normal fw-semibold">Sekúnd</span>
        </div>
      </div>
      <p
        v-if="props.data.description"
        class="mb-6"
      >
        {{ props.data.description }}
      </p>
    </div>
  </div>
</template>
